export default __webpack_public_path__ + "img/publication/publication3_1500.webp";